export default "__VITE_ASSET__8WX1$hSP__"